import { animate, AnimationMetadata, style } from '@angular/animations';

export const baseAnimationTiming = '0.5s 0.3s cubic-bezier(0.540, 0, 0.245, 1)';
export const fastAnimationTiming = '0.2s 0.1s cubic-bezier(0.540, 0, 0.245, 1)';

// can't use a function because of trouble with production mode
// https://github.com/angular/angular/issues/27642

// we should set a translate of 120% because of some element's parent padding

export const noop = [];

//////////////////////// SLIDES /////////////////////
// HORIZONTAL
export const slideFromLeft: AnimationMetadata[] = [
  style({transform: `translateX(-120%)`}),
  animate(baseAnimationTiming, style({transform: `translateX(0%)`}))
];

export const slideFromRight: AnimationMetadata[] = [
  style({transform: `translateX(120%)`}),
  animate(baseAnimationTiming, style({transform: `translateX(0%)`}))
];

export const slideToLeft: AnimationMetadata[] = [
  style({transform: `translateX(0%)`}),
  animate(baseAnimationTiming, style({transform: `translateX(-100%)`}))
];

export const slideToRight: AnimationMetadata[] = [
  style({transform: `translateX(0%)`}),
  animate(baseAnimationTiming, style({transform: `translateX(100%)`}))
];

// VERTICAL
export const slideFromBottom: AnimationMetadata[] = [
  style({transform: `translateY(120%)`}),
  animate(baseAnimationTiming, style({transform: `translateY(0%)`}))
];

export const slideFromTop: AnimationMetadata[] = [
  style({transform: `translateY(-120%)`}),
  animate(baseAnimationTiming, style({transform: `translateY(0%)`}))
];

export const slideToBottom: AnimationMetadata[] = [
  style({transform: `translateY(0%)`}),
  animate(baseAnimationTiming, style({transform: `translateY(100%)`}))
];

export const slideToTop: AnimationMetadata[] = [
  style({transform: `translateY(0%)`}),
  animate(baseAnimationTiming, style({transform: `translateY(-100%)`}))
];

//////////////////////// EXPANSION /////////////////////
export const expanseDown: AnimationMetadata[] = [
  style({height: 0}),
  animate(baseAnimationTiming, style({height: '*'}))
];

//////////////////////// FADE /////////////////////
export const fadeIn: AnimationMetadata[] = [
    style({opacity: 0}),
    animate(fastAnimationTiming, style({opacity: 1}))
  ];

export const fadeOut: AnimationMetadata[] = [
  style({opacity: 1}),
  animate(baseAnimationTiming, style({opacity: 0}))
];

//////////////////////// ZOOM /////////////////////
export const zoomIn: AnimationMetadata[] =  [
      style({transform: `scale(0.3)`, opacity: 0.3}),
      animate(fastAnimationTiming, style({transform: `scale(1)`, opacity: 1}))
    ];

export const zoomOut: AnimationMetadata[] =  [
  style({transform: `scale(1)`, opacity: 1}),
  animate(fastAnimationTiming, style({transform: `scale(0)`, opacity: 0}))
];
